<template>
  <div class="card-block">
    <h3 class="card-title">
    </h3>
    <div class="row" v-if="isLoading">
      <div class="col-md-12 card-stat">
        <loading-indicator></loading-indicator>
      </div>
    </div>
    <div class="row" v-else>
      <!-- (balances.credit - balances.usage) < 0 -->
      <div class="col-md-12">
        <div class="">
          <div class="row">
            <div class="col-md-10 col-xs-12">
              <div class="font-size-24 blue-grey-700 m-b-5">Team name : {{team.name}}
                <span v-if="team.is_reseller" class="font-size-18 red-600">[ Reseller ]</span>
                <span v-else-if="team.has_reseller" class="font-size-18 blue-600">[ Sub Team ]</span>
                <span v-else class="font-size-18 grey-600">[ Normal ]</span>
              </div>
              <div class="font-size-14" v-if="team.has_reseller">Reseller : {{team.reseller ? team.reseller.name : ''}}</div>
              <div class="font-size-14">
              </div>
            </div>
            <div class="col-md-2 col-xs-12">
              <div class="counter counter-lg text-xs-right">
                <router-link
                  v-bind:to="`/${$route.params.namespace}/${currentPage}/teams/${team.namespace}/edit`"
                  class="btn btn-lg btn-default"
                  alt="Edit Team"> <i class="icon md-edit" aria-hidden="true"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    LoadingIndicator,
  },
  props: {
    team: {
      type: Object,
    },
    currentUser: {
      type: Object,
    },
  },
  watch: {
    team: function(value) {
      if (value) {
        this.isLoading = false;
        this.$emit('loadChanged', false);
      }
    },
  },
  computed: {
    currentPage: function () {
      if (this.$route.params.subnamespace && this.currentUser.team.is_superadmin) {
        return 'admin';
      } else if (this.$route.params.subnamespace && this.currentUser.team.is_reseller) {
        return 'reseller';
      } else {
        return 'self';
      }
    },
  },
  created: function() {
    this.isLoading = true;
    this.$emit('loadChanged', true);
  },
  data: function () {
    return {
      isLoading: false,
    };
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TeamInfo.vue?6c85411b